// @flow

import React from 'react';
import { StyledModal } from 'sarsaparilla';

import DivisionDetail from './DivisionDetail';
import type { PermitType } from '../types';

type propTypes = {
    permit: PermitType,
    divisionId: string,
    isOpen: boolean,
    onRequestClose: () => void,
    hasMap?: boolean,
};

const DivisionDetailsModal = ({
    permit,
    divisionId,
    isOpen,
    onRequestClose,
    hasMap,
}: propTypes) => (
    <StyledModal
        shouldShowCloseButton
        shouldActionsStickInMobile
        size={hasMap ? "xxl" : "md"}
        isOpen={isOpen}
        heading={permit?.divisions?.[divisionId]?.name}
        onRequestClose={onRequestClose} >

        <DivisionDetail divisionId={divisionId} permit={permit} hasMap={hasMap} />

    </StyledModal>
);

export default DivisionDetailsModal;